var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97081 4.99449L8.96954 4.69941C8.9594 3.52902 8.88885 2.48478 8.76717 1.82302C8.76717 1.81109 8.63445 1.15476 8.5499 0.936296C8.41718 0.620525 8.17718 0.352488 7.87627 0.18267C7.63537 0.0615015 7.38264 0 7.1181 0C6.91015 0.00963879 6.5672 0.114284 6.32243 0.202018L6.11902 0.279971C4.77177 0.815128 2.19634 2.5638 1.20999 3.63319L1.13727 3.70794L0.812723 4.0582C0.60818 4.32623 0.5 4.65394 0.5 5.00643C0.5 5.3222 0.596362 5.63797 0.789087 5.89315C0.846784 5.97583 0.93972 6.08189 1.02244 6.17151L1.33833 6.50218C2.42538 7.60357 4.77904 9.14847 5.99902 9.66036C5.99902 9.67138 6.7572 9.98807 7.1181 10H7.16628C7.71991 10 8.23718 9.68423 8.50172 9.17386C8.57399 9.03433 8.64331 8.76102 8.69604 8.52097L8.79081 8.06774C8.89899 7.3389 8.97081 6.22086 8.97081 4.99449ZM14.2473 6.26528C14.9391 6.26528 15.5 5.69892 15.5 5.00037C15.5 4.30182 14.9391 3.73545 14.2473 3.73545L11.1646 4.00808C10.6219 4.00808 10.1819 4.45144 10.1819 5.00037C10.1819 5.54838 10.6219 5.99266 11.1646 5.99266L14.2473 6.26528Z",
    fill: "#2563EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/Arrow -left.3f5eb04c7f11b2dd86910e44ebd4f054.svg";
export { ForwardRef as ReactComponent };